export const serviceOfferings = [
  // These pages do not exist yet
  // {
  //   image:
  //     "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/corgi.webp",
  //   title: "Fundraising",
  //   description: "Systems that run smoothly so your team can focus on animals.",
  //   bgColor: "bg-[#FE994F]",
  //   imageClass: "object-[center_40%]",
  //   link: "#",
  // },
  // {
  //   image:
  //     "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/white-cat-profile.webp",
  //   title: "Awareness & Reach",
  //   description: "Systems that run smoothly so your team can focus on animals.",
  //   bgColor: "bg-[#46A4DD]",
  //   imageClass: "object-[center_20%]",
  //   link: "#",
  // },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/cat-in-chair.webp",
    title: "Website Development",
    description: "Built to grow your rescue — more adoptions, more donors, less admin.",
    bgColor: "bg-[#FE994F]",
    imageClass: "object-[center_40%]",
    link: "/consulting-services/technology",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/white-cat.webp",
    title: "Grant Writing",
    description: "Expert strategists + AI tools to find and win the right grants, faster.",
    bgColor: "bg-[#7EC8E3]",
    imageClass: "object-[center_30%]",
    link: "/consulting-services/grant-writing",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/pitbull2.webp",
    title: "Google Ad Grants",
    description: "Reach more adopters, donors, and volunteers — no ad spend required.",
    bgColor: "bg-[#FE994F]",
    imageClass: "object-[center_30%]",
    link: "/consulting-services/google-adwords",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/cat-looking-down.webp",
    title: "Corporate Sponsorships",
    description: "We find and close corporate sponsors on your behalf, so you can focus on the animals.",
    bgColor: "bg-[#46A4DD]",
    imageClass: "object-[center_0%]",
    link: "/consulting-services/corporate-sponsorship",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-cat.webp",
    title: "Social Media",
    description: "Inspiring content that grows your audience — without taking time away from your animals.",
    bgColor: "bg-[#FE994F]",
    imageClass: "object-[center_30%]",
    link: "/consulting-services/marketing",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/mixed-dog.webp",
    title: "SEO",
    description: "Visibility saves lives. Our SEO strategies help rescues grow awareness, traffic & community impact.",
    bgColor: "bg-[#7EC8E3]",
    imageClass: "object-[center_30%]",
    link: "/consulting-services/seo",
  },
];

export const serviceDetails = [
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/black-cat.jpg",
    title: "SEO",
    subheading: "Hard to stand out online?",
    description:
      "We help animal nonprofits rank higher on Google & Maps so adopters, donors, & volunteers can find you first. Sponsor a Pet’s proven SEO strategies help rescues grow visibility, trust, & traffic.",
    bgColor: "bg-[#46A4DD]",
    imageClass: "object-center",
    link: "/consulting-services/seo",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/pug.webp",
    title: "Website Development",
    subheading: "Is your website helping your mission grow?",
    description:
      "We design modern, mission-driven websites that help animal nonprofits attract adopters, donors, & volunteers. With hundreds of rescue builds behind us, our process turns ideas into results that grow your impact online.",
    bgColor: "bg-[#46A4DD]",
    imageClass: "object-center",
    link: "/consulting-services/technology",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/cat-in-wall.jpg",
    title: "Grant Writing",
    subheading: "Spending hours on grants that never get funded?",
    description:
      "We help animal nonprofits secure more funding with data-driven research, automation, & AI-assisted writing. From strategy to reporting, our process helps you win more grants while saving time & strengthening relationships with funders.",
    bgColor: "bg-[#46A4DD]",
    imageClass: "object-center",
    link: "/consulting-services/grant-writing",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/dalmation5.webp",
    title: "Social Media & Content Creation",
    subheading: "Is your story reaching the people who need to hear it?",
    description:
      "We help animal nonprofits grow awareness, trust, & donations through strategic storytelling. From content plans to full campaigns, our team creates social strategies that amplify your mission & connect with the right audience.",
    bgColor: "bg-[#46A4DD]",
    imageClass: "object-center",
    link: "/consulting-services/marketing",
  },
  {
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/german-shepard.webp",
    title: "Corporate Sponsorships",
    subheading:
      "Struggling to find sponsors who truly align with your mission?",
    description:
      "We help nonprofits attract, pitch, & retain corporate partners through storytelling, strategy, & proven outreach systems. From first contact to long-term partnerships, our process helps you secure sponsors who care about your cause.",
    bgColor: "bg-[#46A4DD]",
    imageClass: "object-center",
    link: "/consulting-services/corporate-sponsorship",
  },
];

export const testimonials = [
  {
    id: 1,
    text: "A refreshing platform that is based on integrity, putting nonprofits first.",
    author: "Nancy Sayle",
    organization: "Fur & Feather",
    initials: "NS",
  },
  {
    id: 2,
    text: "Sponsor a Pet helped us increase our online donations by 300% in just 6 months. Their marketing strategies are game-changing.",
    author: "Sarah Johnson",
    organization: "Happy Tails Rescue",
    initials: "SJ",
  },
  {
    id: 3,
    text: "The Google AdWords Grant management service has brought us so many new supporters. We couldn't have done it without their expertise.",
    author: "Mike Rodriguez",
    organization: "Second Chance Animal Shelter",
    initials: "MR",
  },
];

export const googleAdFaqs = [
  {
    question: "How long does it take to get approved?",
    answer:
      "Most nonprofits are approved for the Google Ad Grant in 2–4 weeks. Sponsor a Pet handles the full process and can often get your account live in as little as 10 business days.",
  },
  {
    question: "What types of nonprofits qualify?",
    answer:
      "Eligible organizations include 501(c)(3) nonprofits with an active, mission-based website — like animal rescues, shelters, and sanctuaries.",
  },
  {
    question: "Can I run adoption or donation ads with the grant?",
    answer:
      "Yes! You can promote adoptions, donations, volunteer programs, and events using your $10,000/month in free ad spend — fully within Google's guidelines.",
  },
  {
    question: "What happens if my account becomes inactive?",
    answer:
      "If your account is suspended or paused, we'll fix compliance issues and reactivate it fast, keeping your grant active month after month.",
  },
  {
    question: "How soon will I see results?",
    answer:
      "Most clients begin seeing increased traffic and engagement within the first week of campaign launch.",
  },
  {
    question: "Can you manage both paid and grant-based Google Ads?",
    answer:
      "Yes, we handle both grant-funded and paid ad campaigns to maximize your visibility and conversions.",
  },
];

export const googleAdExpertise = [
  {
    title: "Full-Service Support",
    description:
      "End-to-end support — from application and account setup to optimization and compliance.",
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/compass.svg",
  },
  {
    title: "Real-Time Insights",
    description: "Custom analytics dashboards showing real-time impact",
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/insights.svg",
  },
  {
    title: "Ad Strategy Expertise",
    description:
      "Specialized ad copy and keyword strategy for rescue and adoption campaigns",
    image:
      "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/announcement.svg",
  },
];

export const googleAdHowItWorks = [
  {
    image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/audience.svg",
    title: "Reach new audiences",
    details: "Connect with new donors, volunteers, advocates, and beneficiaries by picking high-quality keywords.",
  },
  {
    image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/amplify.svg",
    title: "Amplify your mission on Google Search",
    details: "Whenever you search for something on Google, ads appear at the top of the results. These ads are paid for by businesses and nonprofits, and your ads could be included for the keywords you bid on!",
  },
  {
    image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/money.svg",
    title: "Automatically receive $10,000 in ad spend each month",
    details: "So long as you comply with the program's rules, the grant will automatically renew each month.",
  },
];

export const corporateSponsorshipHowWeHelp = {
  bgColor: "bg-orange",
  title: "How we help you win corporate sponsorships",
  titleColor: "text-blue-navy",
  accentColor: "text-white",
  cardBg: "bg-blue",
  description: "Our approach blends strategy, storytelling, and systems that make sponsorships last. From finding the right brands to building long-term partnerships, we handle the moving parts so you can stay focused on your mission.",
  items: [
    {
      title: "Target the Right Brands",
      description: "We identify mission-aligned companies, segment opportunities, and build a focused sponsorship pipeline so every conversation matters.",
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/target.svg",
    },
    {
      title: "Tell a Compelling Story",
      description: "We shape your value proposition, craft sponsor-ready assets, and align your board and team around a clear, unified pitch.",
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/pencil.svg",
    },
    {
      title: "Build Lasting Partnerships",
      description: "We manage outreach, reporting, and stewardship systems that convert one-time gifts into multi-year sponsorships.",
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/give.svg",
    },
  ],
};

export const seoHowWeHelp = {
  bgColor: "bg-orange",
  title: "How we help you grow online visibility",
  titleColor: "text-blue-navy",
  accentColor: "text-white",
  cardBg: "bg-blue",
  description: 'Every search for "animal rescue near me" or "adopt a cat in [city]" is a chance to grow your mission. Our nonprofit SEO strategies help your organization show up first — when people are ready to foster, adopt, or give.',
  items: [
    {
      title: "Audit & Strategy",
      bullets: [
        "Technical site & content review",
        "Keyword & content mapping",
        "Competitive landscape analysis",
      ],
      bulletIcon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/check.svg",
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/search.svg",
    },
    {
      title: "Local Optimization",
      bullets: [
        "Google Business setup & optimization",
        "Local keyword targeting & backlinks",
        "Review generation strategy",
      ],
      bulletIcon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/check.svg",
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/location.svg",
    },
    {
      title: "Growth & Reporting",
      bullets: [
        "Ranking, traffic, & conversion reports",
        "Monthly analytics dashboard",
        "Continuous improvement plan",
      ],
      bulletIcon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/check.svg",
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/graph-up.svg",
    },
  ],
};

export const seoWhyItMatters = {
  imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/rabbit2.webp",
  imageAlt: "A rabbit",
  title: "If they can't find you, they can't help you",
  description: "You're rescuing animals, running events, and keeping up with volunteers — but your website isn't showing up where it matters. Competing shelters dominate local search, and potential adopters can't find your listings or donation pages.",
  items: [
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/magnifying-glass.svg",
      heading: "Hard for locals to find your rescue online?",
      text: "We optimize your Google Business profile & website so your rescue appears where people actually search — on Google & Maps.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/graph-down.svg",
      heading: "Ranking below big national organizations?",
      text: "Our SEO strategy helps small animal nonprofits compete locally, highlighting your mission in searches that matter most.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/web.svg",
      heading: "Getting traffic but not the right visitors?",
      text: "We attract adopters, donors, & volunteers who are actively searching for rescues like yours — not just random clicks.",
    },
  ],
};

export const corporateSponsorshipWhyItWorks = {
  imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/corp-sponsorships.png",
  imageAlt: "Corporate sponsorships",
  title: "Why our sponsorship approach works",
  description: "Our model combines strategy, outreach systems, and long-term stewardship to help your organization secure — and keep — high-value corporate partners.",
  items: [
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/handshake.svg",
      heading: "Struggling to find sponsors who truly align?",
      text: "We help you identify mission-driven brands that believe in your cause.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/sparkle.svg",
      heading: "Hard to stand out when pitching to brands?",
      text: "We craft messaging & assets that speak your sponsors' language.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/reset.svg",
      heading: "Partnerships fade without a system to sustain them?",
      text: "We set up outreach & reporting workflows that keep support strong year-round.",
    },
  ],
};

export const corporateSponsorshipAssociatedServices = [
  {
    bg: "bg-blue/20",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-laptop.webp",
    imageAlt: "Digital Marketing Automation",
    imageClassName: "h-[175px] w-[175px] lg:h-[225px] lg:w-[225px] object-contain",
    label: "Digital Marketing Automation",
    link: "#",
  },
  {
    bg: "bg-blue",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-notepad.webp",
    imageAlt: "Grant Writing",
    imageClassName: "h-[175px] w-[175px] lg:h-[225px] lg:w-[225px] object-contain",
    label: "Grant Writing",
    link: "/consulting-services/grant-writing",
  },
];

export const grantWritingAssociatedServices = [
  {
    bg: "bg-blue/20",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-puzzle.webp",
    imageAlt: "Corporate Sponsorships",
    imageClassName: "h-[300px] w-[300px] md:h-[400px] md:w-[400px] object-contain",
    label: "Corporate Sponsorships",
    link: "/consulting-services/corporate-sponsorship",
  },
  {
    bg: "bg-blue",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-donate.webp",
    imageAlt: "Fundraising",
    imageClassName: "h-[300px] w-[300px] md:h-[400px] md:w-[400px] object-contain",
    label: "Fundraising",
    link: "/consulting-services/donor-discovery",
  },
];

export const googleAdAssociatedServices = [
  {
    bg: "bg-blue/20",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-puzzle.webp",
    imageAlt: "Corporate Sponsorships",
    imageClassName: "h-[300px] w-[300px] md:h-[400px] md:w-[400px] object-contain",
    label: "Corporate Sponsorships",
    link: "/consulting-services/corporate-sponsorship",
  },
  {
    bg: "bg-blue",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-notepad.webp",
    imageAlt: "Grant Writing",
    imageClassName: "h-[175px] w-[200px] md:w-full md:h-60 object-contain",
    label: "Grant Writing",
    link: "/consulting-services/grant-writing",
  },
  {
    bg: "bg-blue-navy",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-social-media.webp",
    imageAlt: "Social Media & Content Creation",
    imageClassName: "h-[150px] md:h-52 aspect-[4/3] object-fill",
    label: "Social Media & Content Creation",
    link: "/consulting-services/marketing",
  },
];

export const googleAdImpactStats = {
  bgColor: "bg-blue/20",
  title: "Impact through ads",
  description: "Every month, our partners see measurable growth — more adoptions, more donations, and more visibility through Google Search. Here's what that impact looks like in numbers.",
  image1Src: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/french-bulldog2.webp",
  image1Alt: "A French bulldog",
  image2Src: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/french-bulldog5.webp",
  image2Alt: "A French bulldog in a yellow sweater",
  stats: [
    { value: "+230%", label: "+230% increase in website visits", bg: "bg-blue-dark1", bgMobile: "bg-blue" },
    { value: "2x", label: "2x increase in monthly donations within 90 days", bg: "bg-orange-dark1", bgMobile: "bg-orange" },
    { value: "400%", label: "400% boost in adoption applications", bg: "bg-blue-dark1", bgMobile: "bg-blue" },
    { value: "300+", label: "300+ animal nonprofits worldwide", bg: "bg-orange-dark1", bgMobile: "bg-orange" },
  ],
  buttonText: "Check My Eligibility",
  buttonTo: "/contact-us",
  buttonColour: "blue",
};

export const seoImpactStats = {
  bgColor: "bg-blue/20",
  title: "See how rescues are growing with local SEO",
  description: "Join 300+ animal nonprofits turning Google searches into supporters.",
  image1Src: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/rabbit3.webp",
  image1Alt: "A rabbit",
  image2Src: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/cat-pill.webp",
  image2Alt: "A cat",
  stats: [
    { value: "+322%", label: "Average increase in local search visibility", bg: "bg-blue-dark1", bgMobile: "bg-blue" },
    { value: "3.2x", label: "More clicks from Google Maps & \"near me\" searches", bg: "bg-orange-dark1", bgMobile: "bg-orange" },
    { value: "215%", label: "Increase in organic website traffic within 6 months", bg: "bg-blue-dark1", bgMobile: "bg-blue" },
    { value: "400%", label: "Boost in Google Business Profile views and map actions", bg: "bg-orange-dark1", bgMobile: "bg-orange" },
  ],
  buttonText: "Check my Eligibility",
  buttonTo: "/contact-us",
  buttonColour: "blue",
};

export const technologyServiceCards = {
  bgColor: "bg-orange",
  title: "Your website is the front door to your organization",
  description: "When visitors land on your site, they decide within seconds whether to stay, explore, or support. Our rescue-focused websites are designed to welcome, inform & inspire action.",
  cardBg: "bg-blue",
  items: [
    {
      title: "Built Around Your Mission",
      description: "Your website should reflect who you are & what you stand for.",
      bullets: [
        "Custom layouts designed for rescues & nonprofits",
        "Clear storytelling that connects with your community",
        "Built to drive donations, adoptions & volunteer signups",
      ],
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/big-paw.svg",
    },
    {
      title: "Stunning Visual Design",
      description: "Create a lasting impression that turns visitors into supporters.",
      bullets: [
        "Modern, accessible, mobile-friendly design",
        "Consistent branding across every page",
        "Visuals that highlight your animals & impact",
      ],
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/paint-brush.svg",
    },
    {
      title: "Made Easy to Manage",
      description: "You shouldn't need a tech team to make updates.",
      bullets: [
        "Simple editing tools & CMS training",
        "Fast performance & reliable hosting",
        "Scalable setup built for future growth",
      ],
      image: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/gear.svg",
    },
  ],
};

export const technologyFaqs = [
  {
    question: "Do you work with small, volunteer-run rescues?",
    answer: "Yes — we scale every project to your budget and needs.",
  },
  {
    question: "Can you rebuild our existing site?",
    answer: "Absolutely. We'll assess what can be reused and modernize what can't.",
  },
  {
    question: "Will you train our staff to update the site?",
    answer: "Yes! Every project includes training and documentation for your team.",
  },
  {
    question: "How long does a typical build take?",
    answer: "Most sites launch in 4–8 weeks, depending on size and integrations.",
  },
];

export const technologyAssociatedServices = [
  {
    bg: "bg-blue",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-laptop.webp",
    imageAlt: "Digital Marketing Automation",
    imageClassName: "h-[175px] w-[175px] lg:h-[225px] lg:w-[225px] object-contain",
    label: "Digital Marketing Automation",
    link: "#",
  },
  {
    bg: "bg-blue-navy",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starkski-seo.webp",
    imageAlt: "SEO",
    imageClassName: "h-[175px] w-[175px] lg:h-[225px] lg:w-[225px] object-contain",
    label: "SEO",
    link: "/consulting-services/seo",
  },
];

export const technologyWhyTrustUs = {
  imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/dalmation7.webp",
  imageAlt: "A dalmatian dog",
  title: "We Make Websites That Matter",
  description: "We've spent years building websites for animal nonprofits. We know your adopters, your donors, your volunteers — and what actually gets them to show up. Every site we build is designed around your mission, not just your brand.",
  items: [
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-check.svg",
      plainIcon: true,
      heading: "Rescue-Focused Design Expertise",
      text: "Built specifically for animal organizations",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-check.svg",
      plainIcon: true,
      heading: "Integrated Tools",
      text: "Connect platforms like Givebutter, FundraiseUp or ShelterLuv",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-check.svg",
      plainIcon: true,
      heading: "Conversion-Ready Layouts",
      text: "Turn visitors into adopters & donors",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-check.svg",
      plainIcon: true,
      heading: "Fast & SEO-Friendly",
      text: "Optimized from day one",
    },
  ],
};

export const technologyWhyItMatters = {
  imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/dalmation3.webp",
  imageAlt: "A dalmatian dog",
  title: "What's holding your nonprofit back online",
  description: "Your rescue saves lives every day — but if your website is outdated, hard to navigate, or slow to load, potential adopters and donors might never see your work.",
  items: [
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/paw.svg",
      heading: "Your website doesn't reflect your mission?",
      text: "We'll create a design that captures your rescue's heart & inspires visitors to take action.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/time.svg",
      heading: "Pages loading slowly or turning visitors away?",
      text: "We build fast, accessible websites that keep supporters engaged from the first click.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/graph-down.svg",
      heading: "Donation forms not converting?",
      text: "We streamline the giving process so it's quick, secure & emotionally compelling.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/puzzle.svg",
      heading: "Adoption, event, or volunteer forms not connected?",
      text: "We'll help you unify everything — so your data, outreach & impact work together.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/patch.svg",
      heading: "Relying on volunteers or patchwork tools to stay online?",
      text: "We build user-friendly websites your team can manage confidently — no tech hero required.",
    },
  ],
};

export const marketingFaqs = [
  {
    question: "Can we review posts before they go live?",
    answer: "Yes! We share a content calendar and drafts in advance so your team can review, request edits, and approve everything before it's published.",
  },
  {
    question: "Do you offer help with paid ads too?",
    answer: "Our social media plans focus on organic content. For paid advertising, check out our Google AdWords service — or ask us about bundling both.",
  },
  {
    question: "What platforms do you manage?",
    answer: "We create and schedule content for Facebook, Instagram, X (formerly Twitter), LinkedIn, and TikTok.",
  },
  {
    question: "Do you handle engagement and responses?",
    answer: "Yes, we offer community management support including replies, DMs, and comment moderation.",
  },
  {
    question: "Can you help grow our following?",
    answer: "Absolutely — our strategies are designed to increase reach, drive engagement, and attract mission-aligned supporters.",
  },
];

export const marketingAssociatedServices = [
  {
    bg: "bg-blue/20",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-graph.webp",
    imageAlt: "Digital Analytics & Reporting",
    imageClassName: "h-[175px] w-[175px] lg:h-[225px] lg:w-[225px] object-contain",
    label: "Digital Analytics & Reporting",
    link: "#",
  },
  {
    bg: "bg-blue",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-donate.webp",
    imageAlt: "Fundraising",
    imageClassName: "h-[175px] w-[175px] lg:h-[225px] lg:w-[225px] object-contain",
    label: "Fundraising",
    link: "/consulting-services/donor-discovery",
  },
  {
    bg: "bg-blue-navy",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-ui.webp",
    imageAlt: "Website Development",
    imageClassName: "h-[175px] w-[175px] lg:h-[225px] lg:w-[225px] object-contain",
    label: "Website Development",
    link: "/consulting-services/technology",
  },
];

export const seoAssociatedServices = [
  {
    bg: "bg-blue-navy",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-social-media.webp",
    imageAlt: "Social Media & Content Creation",
    imageClassName: "h-[150px] md:h-52 aspect-[4/3] object-fill",
    label: "Social Media & Content Creation",
    link: "/consulting-services/marketing",
  },
  {
    bg: "bg-blue/20",
    imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/starski-ui.webp",
    imageAlt: "Website Development",
    imageClassName: "h-[175px] w-[175px] lg:h-[225px] lg:w-[225px] object-contain",
    label: "Website Development",
    link: "/consulting-services/technology",
  },
];

export const seoFaqs = [
  {
    question: "What is included in your SEO service?",
    answer: "We handle keyword research, on-page optimization, technical audits, and content recommendations to improve your search rankings.",
  },
  {
    question: "How long does it take to see SEO results?",
    answer: "SEO is a long-term strategy, but most nonprofits see measurable improvements in visibility within 3–6 months.",
  },
  {
    question: "Can you help with blog content or page edits?",
    answer: "Yes, we can support content creation and page optimization to align with high-value search terms.",
  },
  {
    question: "Can we appear on Google Maps without a public location?",
    answer: "Yes — we can optimize your Google Business Profile for service-area visibility.",
  },
  {
    question: "Do you work with small rescues or volunteer-run nonprofits?",
    answer: "Absolutely. Our local SEO programs are built to fit organizations of any size or budget.",
  },
];

export const marketingWhyItMatters = {
  imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/flashy-bird.webp",
  imageAlt: "A cockatiel bird",
  title: "Your story deserves to be heard",
  description: "Social media is one of the most powerful tools rescues have to grow their reach—when it's done strategically. Here's what strong social content makes possible:",
  items: [
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/time.svg",
      heading: "Struggling to stay consistent?",
      text: "We plan, schedule & post for you — keeping your rescue active without last-minute stress.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/heart.svg",
      heading: "Great stories, low engagement?",
      text: "We turn everyday rescue moments into emotional posts that build awareness & inspire action.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/down.svg",
      heading: "Growing followers but not your mission?",
      text: "We help you attract adopters, donors, & volunteers — not just likes.",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/community.svg",
      heading: "Feeling unseen in the algorithm noise?",
      text: "We design data-driven content that helps your rescue stand out & reach local supporters.",
    },
  ],
};

export const marketingWhyTrustUs = {
  imageSrc: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/yellow-bird.webp",
  imageAlt: "A yellow parrot",
  title: "Why animal organizations trust us",
  description: "We know how to speak the language of animal lovers — and we specialize in helping rescues and nonprofits grow their online impact. Our main trust points include:",
  items: [
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-check.svg",
      plainIcon: true,
      heading: "Experts in animal rescue marketing",
      text: "",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-check.svg",
      plainIcon: true,
      heading: "Affordable nonprofit-friendly pricing",
      text: "",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-check.svg",
      plainIcon: true,
      heading: "Tailored content for adoption, fundraising, and awareness goals",
      text: "",
    },
    {
      icon: "https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/orange-check.svg",
      plainIcon: true,
      heading: "Proven strategies for growing engaged communities",
      text: "",
    },
  ],
};

export const grantWritingSponsorships = [
  {
    title: "Prospect Research & Data Hygiene",
    action: "We build clean, enriched contact lists; segment by values, industry, and giving history",
    outcome: "Targets only high-probability brands—no wasted outreach.",
    bg: "bg-blue-light1",
  },
  {
    title: "Sponsorship Strategy & Asset Kit",
    action: "We craft value propositions, pitch decks, one-pagers, talking points",
    outcome: 'Gives board & staff a unified, "investor-grade" story.',
    bg: "bg-blue",

  },
  {
    title: "Automated Multi-Channel Outreach",
    action: "Email + LinkedIn cadences, timed follow-ups, A/B messaging",
    outcome: "Keeps your org top-of-mind while you focus on operations.",
    bg: "bg-orange",

  },
  {
    title: "Relationship Stewardship & Renewal",
    action: "On-boarding playbooks, recognition plans, quarterly check-ins",
    outcome: "Converts one-off gifts into multi-year partnerships.",
    bg: "bg-blue-light1",
  },
  {
    title: "Impact Tracking & ROI Reporting",
    action: "Sponsor-facing dashboards, KPI snapshots, case-study templates",
    outcome: "Proves value—boosts retention and upgrade rates.",
    bg: "bg-blue",

  },
  {
    title: "Capacity Building",
    action: "Staff workshops + optional AI tools for ongoing prospect scoring",
    outcome: "Leaves your team stronger long after engagement ends.",
    bg: "bg-orange",

  },
];
